<router-outlet #outlet class="rv-animated-router"></router-outlet>
<ng-template #errorToast>
  <toast [type]="'error'">{{ error }}</toast>
</ng-template>
